import { RadioGroup, Typography } from '@mui/material';
import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { VrsCallCommentsHelperText } from 'features/call/vrs-call-comments/components';
import { AbuseFormValue } from 'features/call/vrs-call-comments/enums';
import type { VrsCallCommentsAbuseFormControl } from 'features/call/vrs-call-comments/interfaces';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { FormControlLabel, Radio } from 'features/ui/elements';

export const VrsCallCommentsAbusePersonControl: FC<
  VrsCallCommentsAbuseFormControl
> = ({ control }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'abuseCommentText',
  });
  return (
    <>
      <Typography variant='subtitle2' color={theme.palette.grey[300]} mt={12}>
        {t('personTitle')}
      </Typography>
      <Controller
        control={control}
        name='personType'
        rules={{ required: true }}
        render={({ field: { ...args }, fieldState }) => (
          <>
            <RadioGroup {...args}>
              <RadioControlLabel
                value={AbuseFormValue.DEAF}
                label={t(AbuseFormValue.DEAF)}
                control={<Radio />}
              />
              <RadioControlLabel
                value={AbuseFormValue.HEARING}
                label={t(AbuseFormValue.HEARING)}
                control={<Radio />}
              />
            </RadioGroup>
            {fieldState.error && (
              <VrsCallCommentsHelperText>
                {t('personValidation')}
              </VrsCallCommentsHelperText>
            )}
          </>
        )}
      />
    </>
  );
};

const RadioControlLabel = styled(FormControlLabel)`
  margin-top: ${theme.spacing(4)};
`;
